
import style from './styles/_externalUser.module.scss';
import { Typography } from '@mui/material';
import Imagen from "../../shared/assets/index";
import { FormExternal } from './components';
import { useAuth } from 'shared/auth';
import { Navigate } from 'react-router-dom';

export const ExternalUser = () => { 

    const { authService } = useAuth();

    if(authService.getUserRoles()?.some(role => !['TFE.generic'].includes(role))){
      return <Navigate to="/" />;
    }
  
    return (
      <main className={style.mainContainer}>
        <div
          className={style.container}
        >
          <header>
            <img src={Imagen.logoTrazabilidad} alt='Trazabilidad' data-testid='icon_trazabilidad'/>
            <img src={Imagen.logoGobernacion} alt="Logo Gobernación" />
          </header>
          <section
            className={style.containerForm}
          >
            <Typography className={style.title}>Formulario para el reporte del Registro Individual de Prestación de Servicios de Salud (RIPS) de los municipios</Typography>
            
            <section className={style.containerFormContent}>
              <Typography className={style.subtitle}>Los campos marcados con (*) son obligatorios.</Typography>
              
              <FormExternal />

            </section>
          </section>
        </div>
      </main>
    )
}
